/* eslint-disable @typescript-eslint/no-unused-vars */

import { ToastContainer } from 'react-toastify'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Link } from 'react-router-dom'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Select } from 'antd'
import { ReturnIcon } from '../../assets/icons/Return'
import { GenericTable } from '../../components/GenericTable/GenericTable'
import { Loading } from '../../components/Loading/Loading'
import { ContainerTitle } from '../../components/TitlePage/TitlePage'
import { Tour } from '../../components/Tour'
import TourPredicoesDetails from '../../utils/JoyRide/tourPredicoesDetails'
import { dateToBr } from '../../utils/transformDate'
import {
  AcoesFiltro,
  AvisoRecorte,
  BarraFiltros,
  CampoFiltro,
  DivImg,
  DivName,
  DivTop,
  LinkWpp,
  // LinkWpp,
  Span,
  SpanData,
} from './HistoricoBaixaDetails.style'
import { usePredictionDetails } from './useHistoricoBaixaDetails'
import { MailIcon } from '../../assets/icons/mail'
import { PhoneIcon } from '../../assets/icons/phone-telephone'
import { WhatsappIcon } from '../../assets/icons/whatsapp-line'
import { UseFormatador } from '../../components/FormatadorCpfCnpj'
import { PaginationHistoryPredict } from '../../components/Pagination/Pagination'

// eslint-disable-next-line import/no-extraneous-dependencies
import 'dayjs/locale/pt-br'
import Tooltips from '../../components/Tooltip'
import { CancelarBaixa } from '../../components/HistoricoDeBaixas/styles'
import { IconCancelarBaixa } from '../../assets/icons/closeOption'
import { Desativar } from '../../components/Desativar'
import DatesPicker from '../../components/Calendar/datePicker'
import { Button } from '../../components/SideBar/Menu.style'

export function HistoricoBaixaDetails() {
  const { formatarCPF } = UseFormatador()
  const {
    historicoBaixaDetail,
    clientData,
    isLoading,
    isLoadingHistory,
    currentPageHistory,
    setCurrentPageHistory,
    cancelaUmaBaixa,
    isCancelar,
    showIsCancelar,
    setIdCancela,
    setDataProx,
    isCancelarBaixa,
    opcoesProduto,
    produtosSelecionados,
    setProdutosSelecionados,
    setDataInicioRascunho,
    setDataFimRascunho,
    aplicarFiltros,
    limparFiltros,
    temFiltroAplicado,
    versaoLimpeza,
  } = usePredictionDetails()

  return (
    <>
      <ToastContainer theme="dark" />
      <ContainerTitle id="saudacaoPredicaoDetail">
        <DivTop>
          <Link to="/historico-baixa">
            <ReturnIcon />
          </Link>
          <Span>Histórico de baixa</Span>
        </DivTop>
        <Tooltips icon={<Tour steps={TourPredicoesDetails} />} text="Tour" />
      </ContainerTitle>
      <DivImg>
        {isLoading ? (
          <Loading contrast />
        ) : (
          <>
            <DivName>{clientData?.nome}</DivName>
            <SpanData>CPF / CNPJ: {formatarCPF(clientData?.cpfcnpj)}</SpanData>
            <SpanData>
              <PhoneIcon /> {clientData?.telefone}
              <MailIcon /> {clientData?.email}
              <WhatsappIcon />
              <LinkWpp
                href={`https://web.whatsapp.com/send?phone=${clientData?.whatsapp}`}
                target="_blank"
              >
                {clientData?.whatsapp}
              </LinkWpp>
            </SpanData>
          </>
        )}
      </DivImg>
      <BarraFiltros>
        <CampoFiltro>
          Produto:
          <Select
            mode="multiple"
            allowClear
            placeholder="Pesquise uma palavra chave"
            value={produtosSelecionados}
            onChange={setProdutosSelecionados}
            style={{ width: '320px' }}
            // O `value` da option e o ID (nome se repete no catalogo). Com value numerico, a busca
            // do rc-select filtra pelo value e nao acharia nada por palavra: dai o filterProp.
            optionFilterProp="label"
            options={opcoesProduto}
          />
        </CampoFiltro>
        <CampoFiltro>
          Baixa a partir de:
          <DatesPicker
            key={`inicio-${versaoLimpeza}`}
            handleDataSelecionada={setDataInicioRascunho}
            size="130px"
            dayjs={null}
          />
        </CampoFiltro>
        <CampoFiltro>
          Baixa até:
          <DatesPicker
            key={`fim-${versaoLimpeza}`}
            handleDataSelecionada={setDataFimRascunho}
            size="130px"
            dayjs={null}
          />
        </CampoFiltro>
        <AcoesFiltro>
          <Button buttonType="SMALL" type="button" onClick={aplicarFiltros}>
            Aplicar
          </Button>
          <Button buttonType="SMALL" type="button" onClick={limparFiltros}>
            Limpar
          </Button>
        </AcoesFiltro>
      </BarraFiltros>
      <AvisoRecorte>
        {temFiltroAplicado
          ? 'Da baixa mais recente para a mais antiga. Mostrando apenas as baixas do recorte selecionado — use "Limpar" para ver o histórico completo.'
          : 'Da baixa mais recente para a mais antiga. O filtro de produto lista o catálogo inteiro da empresa, não apenas os produtos deste cliente.'}
      </AvisoRecorte>
      <GenericTable
        font="14px"
        spacing="20px"
        vendas
        headers={[
          'ID',
          'Produto',
          'Data da baixa',
          'Próx. compra',
          'Cancelar Baixa',
        ]}
      >
        {isLoadingHistory ? (
          <Loading contrast={false} />
        ) : (
          historicoBaixaDetail &&
          Array.isArray(historicoBaixaDetail.content) &&
          // `item.id` e o id do PRODUTO, e o mesmo produto aparece uma vez por baixa — como key
          // sozinho, produz duplicata no React. A data da baixa desempata.
          historicoBaixaDetail.content.map(item => (
            <tr key={`${item.id}-${item.dataHora}-${item.dataProximaCompra}`}>
              {/* <td>{item.id}</td> */}
              <td>{item.id}</td>
              <td className="col2">{item.nome}</td>
              <td className="col3">{dateToBr(item.dataHora)}</td>
              <td className="colVendas6">{dateToBr(item.dataProximaCompra)}</td>
              <td className="colVendas6">
                <CancelarBaixa
                  onClick={() => {
                    showIsCancelar()
                    setIdCancela(item.id)
                    setDataProx(item.dataProximaCompra)
                  }}
                >
                  <IconCancelarBaixa />
                </CancelarBaixa>
              </td>
            </tr>
          ))
        )}
      </GenericTable>
      {!isLoadingHistory &&
        Array.isArray(historicoBaixaDetail.content) &&
        historicoBaixaDetail.content.length === 0 && (
          <AvisoRecorte>
            {temFiltroAplicado
              ? 'Nenhuma baixa encontrada para o filtro selecionado.'
              : 'Este cliente ainda não possui baixas registradas.'}
          </AvisoRecorte>
        )}
      <PaginationHistoryPredict
        pageNumber={currentPageHistory}
        pageSize={historicoBaixaDetail.totalElements}
        offSet={historicoBaixaDetail.size}
        onClick={page => setCurrentPageHistory(page)}
      />
      {isCancelar && (
        <Desativar
          botaoNao={showIsCancelar}
          botaoSim={isCancelarBaixa}
          texto="Tem certeza que deseja cancelar esta baixa?"
        />
      )}
    </>
  )
}
